import { useCanvasCommentsMirrorState } from "@/pages/canvas/context/CanvasCommentsMirrorContext";
import { useCanvasNodesMirror } from "@/pages/canvas/context/CanvasNodesMirrorContext";
import { nodeBoundsById } from "@/pages/canvas/utils/nodeBounds";
import { useMemo } from "react";
import {
  buildCommentRailItems,
  type CommentRailItem,
} from "./canvasRailCommentsModel";

export interface CanvasRailCommentsState {
  items: CommentRailItem[];
  threadsSynced: boolean;
  isEmpty: boolean;
}

/**
 * The Comments section's rows. Threads arrive through the mirror the pin
 * layer publishes from inside the room; pin positions resolve here against
 * the live nodes mirror, so a row's Locate target follows its anchor between
 * publishes.
 */
export function useCanvasRailComments(
  canvasId: string,
): CanvasRailCommentsState {
  const { threads, threadsSynced } = useCanvasCommentsMirrorState(canvasId);
  const rawNodes = useCanvasNodesMirror(canvasId);

  const items = useMemo(
    () => buildCommentRailItems(threads, nodeBoundsById(rawNodes)),
    [threads, rawNodes],
  );

  return { items, threadsSynced, isEmpty: items.length === 0 };
}
